import { render } from "./IBackupStatusDropdown.vue?vue&type=template&id=5a7c9048"
import script from "./IBackupStatusDropdown.vue?vue&type=script&lang=js"
export * from "./IBackupStatusDropdown.vue?vue&type=script&lang=js"

import "./IBackupStatusDropdown.vue?vue&type=style&index=0&id=5a7c9048&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__